import { Routes } from '@angular/router';

// component nicht über index laden, ergibt runtime fehler
import { StoragePlaceComponent } from './storage-place.component';
import { ContainerComponent } from './container/container.component'
import { AuthGuard } from '../services/index';

export const storagePlaceRoutes: Routes = [
    { path: 'storagePlace', component: StoragePlaceComponent, canActivate: [AuthGuard]  },
    { path: 'container/:id', component: ContainerComponent, canActivate: [AuthGuard]  }
];


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/storage-place/storage-place.routes.ts